if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initMobileMenu();
		initNavigation();
		hideTopNavigationIfScrolled();  // if already scrolled (on page refresh)
		hideTopNavigationOnScroll();
	});
} else {
	initMobileMenu();
	initNavigation();
	hideTopNavigationIfScrolled();  // if already scrolled (on page refresh)
	hideTopNavigationOnScroll();
}

function hideTopNavigationOnScroll() {
	window.addEventListener('scroll', function () {
		hideTopNavigationIfScrolled();
	});
}

function hideTopNavigationIfScrolled() {
	const navBar = document.getElementById('top-navigation');
	if (!navBar) {
		return;
	}
	const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	const navBarContent = navBar.querySelector(':scope > nav');

	if (screenWidth >= 1000) {
		if (window.scrollY > 0) {
			navBarContent.style.opacity = 0;
			navBarContent.style.transitionDelay = '0ms';
			navBar.classList.add('delay-100', 'h-0', 'overflow-hidden');
			navBar.classList.remove('h-10');
		} else {
			navBarContent.style.opacity = 1;
			navBarContent.style.transitionDelay = '300ms';
			navBar.classList.add('h-10');
			navBar.classList.remove('delay-100', 'h-0', 'overflow-hidden');
		}
	}
}

const hiddenClasses = ['phone:hidden', 'tablet:hidden'];

function initMobileMenu() {
	const navigation = document.getElementById('neos-navigation');

	const mobileMenuButton = document.getElementById('mobile-menu-button');
	mobileMenuButton?.addEventListener('click', toggleMobileMenu);

	const mobileMenuCloseButton = document.getElementById('mobile-menu-close-button');
	mobileMenuCloseButton?.addEventListener('click', toggleMobileMenu);

	const mobileSubmenus = document.querySelectorAll('[data-submenu]');
	for (let submenu of mobileSubmenus) {
		submenu.addEventListener('click', function (e) {
			if (!isMobile()) {
				return;
			}

			e.preventDefault();
			e.stopPropagation();

			let closestSubmenu = e.target.closest('[data-submenu]');
			let open = closestSubmenu.dataset.submenu === 'open';
			if (open) {
				closestSubmenu.setAttribute('data-submenu', 'closed');
			} else {
				closestSubmenu.setAttribute('data-submenu', 'open');
			}
		});
	}


	function toggleMobileMenu(event) {
		event.preventDefault();
		event.stopPropagation();

		let expanded = navigation.dataset.mobileMainMenuExpanded === 'true';
		if (expanded) {
			closeAndResetAllMenus();
		} else {
			navigation.setAttribute('data-mobile-main-menu-expanded', 'true');
			document.addEventListener('click', clickOutsideOfMobileMenu)
		}

		mobileMenuButton.setAttribute('aria-expanded', expanded.toString());
		navigation.setAttribute('aria-expanded', expanded.toString());
	}
}

function clickOutsideOfMobileMenu(event) {
	if (event.target.closest('[data-mobile-main-menu-expanded="true"]') === null) {  // outside of navigation
		event.preventDefault();
		event.stopPropagation();
		closeAndResetAllMenus();
	}
}

function initNavigation() {
	const navigation = document.getElementById('neos-header');
	const mainMenuSelector = '[data-main-menu]';
	window.mobileMenuActive = isMobile();
	if (!navigation) {
		return;
	}

	for (const mainMenuButton of navigation.querySelectorAll(mainMenuSelector + ' > a')) {
		mainMenuButton.addEventListener('click', clickMainMenuButton);
		mainMenuButton.addEventListener('mouseenter', enterMainMenuButton);
		mainMenuButton.addEventListener('mouseout', leaveMainMenuButton);
	}
	for (const mainMenuContent of navigation.querySelectorAll(mainMenuSelector + ' > div')) {
		mainMenuContent.addEventListener('mouseleave', leaveExpandedMainMenu);
	}
	for (const mainMenuExternalLink of navigation.querySelectorAll('#main-nav a[target="_blank"]')) {
		mainMenuExternalLink.addEventListener('click', closeAndResetAllMenus);
	}
	window.addEventListener('resize', resetIfMenuTypeChanged);

	document.addEventListener('keydown', function (event) {
		if (event.key === "Escape") {
			closeMainMenus(navigation);
		}
	});

	function leaveExpandedMainMenu(event) {
		if (isMobile()) {
			return;
		}
		closeMainMenus(navigation);
	}

	function leaveMainMenuButton(event) {
		if (isMobile()) {
			return;
		}
		let currentItem = event.target.closest(mainMenuSelector);
		if (!currentItem) {
			return;
		}
		let elementMouseIsOver = document.elementFromPoint(event.clientX, event.clientY)?.closest(mainMenuSelector);
		if (elementMouseIsOver !== currentItem) {
			currentItem.setAttribute('data-main-menu', 'closed');
		}
	}

	function resetIfMenuTypeChanged() {  // if we switched between the desktop and mobile navigation menu => reset
		if (window.mobileMenuActive !== isMobile()) {
			window.mobileMenuActive = isMobile();
			closeAndResetAllMenus();
		}
	}

	function enterMainMenuButton(event) {
		if (isMobile()) {
			return;
		}
		let currentItem = event.target.closest(mainMenuSelector);
		closeMainMenus(navigation);
		currentItem.setAttribute('data-main-menu', 'open');
	}

	function clickMainMenuButton(event) {
		if (event.target.closest('li')?.querySelectorAll('div')?.length === 0) {  // if not a menu, follow the link
			return;
		}
		event.preventDefault();
		event.stopPropagation(); // important on mobile

		if (isMobile()) {
			handleMobileMenuItemClick(event);
		} else {
			let currentItem = event.target.closest(mainMenuSelector);
			let closed = currentItem.dataset.mainMenu === 'closed';
			closeMainMenus(navigation);
			if (closed) {
				currentItem.setAttribute('data-main-menu', 'open');
			}
		}
	}

	function handleMobileMenuItemClick(event) {
		let mainMenu = event.target.parentNode;
		let mainMenuOpen = mainMenu.dataset.mainMenu === 'open';
		if (mainMenuOpen) {
			mainMenu.setAttribute('data-main-menu', 'closed');
			for (let closedMainMenu of navigation.querySelectorAll('[data-main-menu]')) {
				closedMainMenu.classList.remove(...hiddenClasses);
			}
			for (let hiddenTopNavigationMainItem of navigation.querySelectorAll('.js-navigation-main-item')) {
				hiddenTopNavigationMainItem.classList.remove(...hiddenClasses);
			}
		} else {
			mainMenu.setAttribute('data-main-menu', 'open');
			for (let closedMainMenu of navigation.querySelectorAll('[data-main-menu="closed"]')) {
				closedMainMenu.classList.add(...hiddenClasses);
			}
			for (let topNavigationMainItem of navigation.querySelectorAll('.js-navigation-main-item')) {
				topNavigationMainItem.classList.add(...hiddenClasses);
			}
		}

		if (event.target.closest('li').classList.contains('js-language-main-nav')) {
			// as the language menu is part of '.header-right' we only hide the meta menu and top navigation
			for (let cssClass of hiddenClasses) {
				navigation.querySelector('#meta-menu').classList.toggle(cssClass);
				navigation.querySelector('.header-right .js-top-navigation').classList.toggle(cssClass);
			}
		} else if (event.target.closest('li').classList.contains('js-top-navigation-menu')) {
			for (let cssClass of hiddenClasses) {
				navigation.querySelector('#meta-menu').classList.toggle(cssClass);
			}
		} else {
			// hide entire secondary nav bar
			for (let cssClass of hiddenClasses) {
				navigation.querySelector('.header-right').classList.toggle(cssClass);
			}
		}
	}
}

function isMobile() {
	const mobileMenuButton = document.getElementById('mobile-menu-button');
	if (!mobileMenuButton) {
		return false;
	}
	const mobileMenuButtonStyle = window.getComputedStyle(mobileMenuButton);
	return mobileMenuButtonStyle.display !== 'none';
}

function closeAndResetAllMenus() {
	const navigation = document.getElementById('neos-navigation');
	navigation.setAttribute('data-mobile-main-menu-expanded', 'false');
	closeMainMenus(navigation);

	// reset
	for (let mainMenu of navigation.querySelectorAll('[data-main-menu]')) {  // show hidden menus
		mainMenu.classList.remove(...hiddenClasses);
	}
	for (let closedMainMenu of navigation.querySelectorAll('.js-navigation-main-item')) {
		closedMainMenu.classList.remove(...hiddenClasses);
	}
	for (let submenu of document.querySelectorAll('[data-submenu]')) {
		submenu.setAttribute('data-submenu', 'closed');
	}
	navigation.querySelector('#meta-menu').classList.remove(...hiddenClasses);
	navigation.querySelector('.header-right .js-top-navigation').classList.remove(...hiddenClasses);
	navigation.querySelector('#search').classList.remove(...hiddenClasses);
	navigation.querySelector('.header-right').classList.remove(...hiddenClasses);
	document.removeEventListener('click', clickOutsideOfMobileMenu);
}
function closeMainMenus(parentContainer) {
	const mainMenuSelector = '[data-main-menu]';
	for (let mainMenu of parentContainer.querySelectorAll(mainMenuSelector)) {
		mainMenu.setAttribute('data-main-menu', 'closed');
	}
}
